// extracted by mini-css-extract-plugin
export default {"title":"AccountLots_title__XGOuJ","addNew":"AccountLots_addNew__sS3EV","noLots":"AccountLots_noLots__CtJDt","lotList":"AccountLots_lotList__IRN6r"};